// @ts-nocheck
import {
  PREBOOK_CONTRACTORS_REQUEST,
  PREBOOK_CONTRACTORS_FAILURE,
  PREBOOK_CONTRACTORS_SUCCESS,
  FETCH_PREBOOK_CONTRACTORS_REQUEST,
  FETCH_PREBOOK_CONTRACTORS_SUCCESS,
  FETCH_PREBOOK_CONTRACTORS_FAILURE,
  CHECK_FOR_HOLDDOWN_DATES_REQUEST,
  CHECK_FOR_HOLDDOWN_DATES_SUCCESS,
  CHECK_FOR_HOLDDOWN_DATES_FAILURE,
} from "../../constants/event/prebook";

const initialState = {
  prebookList: [],
  isLoading: true,
  currentPage: 1,
  totalPages: 1,
  searchString: "",
  addLoading: false,
};

export const prebookReducer = (state = initialState, action) => {
  switch (action?.type) {
    // fetch prebooking list
    case FETCH_PREBOOK_CONTRACTORS_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload,
      };

    case FETCH_PREBOOK_CONTRACTORS_SUCCESS:
      return {
        ...state,
        prebookList: action?.payload?.data,
        totalPages: action?.payload?.totalPages,
        currentPage: action?.payload?.currentPage,
        isLoading: false,
      };
    case FETCH_PREBOOK_CONTRACTORS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // prebooking contractors
    case PREBOOK_CONTRACTORS_REQUEST:
      return {
        ...state,
        addLoading: true,
      };

    case PREBOOK_CONTRACTORS_SUCCESS:
      return {
        ...state,
        addLoading: false,
      };
    case PREBOOK_CONTRACTORS_FAILURE:
      return {
        ...state,
        addLoading: false,
      };

    // check for holddown dates
    case CHECK_FOR_HOLDDOWN_DATES_REQUEST:
      return {
        ...state,
        addLoading: true,
      };

    case CHECK_FOR_HOLDDOWN_DATES_SUCCESS:
      return {
        ...state,
        addLoading: false,
      };

    case CHECK_FOR_HOLDDOWN_DATES_FAILURE:
      return {
        ...state,
        addLoading: false,
      };

    default:
      return state;
  }
};

export default prebookReducer;